export default __webpack_public_path__ + "static/media/t12.min.31bb8632.png";